module.exports = __webpack_public_path__ + "static/media/logo_transparent.2c432f30.png";